import bugsnag from 'bugsnag-js';
import Vue from 'vue';
import BugsnagVue from 'bugsnag-vue';

const bugsnagClient = bugsnag("441f595f5555af1c456481020db3c17f");

bugsnagClient.use(BugsnagVue(Vue));

export default bugsnagClient;
